"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomElement = void 0;
const defaults_1 = require("./defaults");
class DomElement {
    constructor(element, options) {
        this._options = Object.assign({}, new defaults_1.DEFAULT_OPTIONS, options);
        this._events = [];
        this._el = this._setElement(element, 'body');
    }
    /**
     * Bind a (delegated) event.
     * @param {String} event
     * @param {Function} fn
     * @param {HTMLElement|Document} el
     * @return DomElement
     */
    on(event, fn, el = null) {
        (el || this._el).addEventListener(event, fn = fn.bind(this), true);
        this._events.push({
            name: event,
            fn: fn,
            el: el
        });
        return this;
    }
    /**
     * Return the main wrapping element.
     * @return {HTMLElement}
     */
    getElement(selector = '') {
        return !selector ? this._el : this._el.querySelector(selector);
    }
    /**
     * Return the main wrapping element.
     * @return {HTMLElement}
     */
    getGeneralElement(selector = '') {
        return document.querySelector(selector);
    }
    /**
     * Check if the root element has child one.
     * @return {Boolean}
     */
    hasElement(selector) {
        return !!this._el.querySelector(selector);
    }
    /**
     * Return the options.
     * @param {string|null} key
     * @return {object}
     */
    getOptions(key = null) {
        return !key ? this._options : this._options[key];
    }
    setOptions(key, value) {
        this._options[key] = value;
    }
    /**
     * Unbind all events and nullify references.
     * @return void
     */
    remove(el = this._el) {
        this._events = this._events.filter((event) => {
            if (event.el === el) {
                el.removeEventListener(event.name, event.fn, true);
                return false;
            }
            return true;
        });
        el.parentNode.removeChild(el);
        if (el === this._el) {
            this._el = null;
            this._options = defaults_1.DEFAULT_OPTIONS;
        }
    }
    /**
     * Query the element in the DOM if its a string.
     * @param {Element|String} el
     * @param {Element|null} fallback
     * @return {Element|null}
     * @protected
     */
    _setElement(el, fallback) {
        if (!el || (!el.nodeType && typeof el !== 'string')) {
            if (fallback) {
                return this._setElement(fallback);
            }
            else {
                throw new Error('Wrong element type provided!');
            }
        }
        if (el.nodeType)
            return el;
        return (this._options.parent || document).querySelector(el);
    }
    /**
     * Communicate changes.
     * @param {String} name
     * @param {Object|null} detail
     * @protected
     */
    _trigger(name, detail = null) {
        let event;
        if (typeof CustomEvent === 'function') {
            event = new CustomEvent(name, {
                detail: detail,
                bubbles: true,
                cancelable: true
            });
        }
        else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(name, true, true, detail);
        }
        this._el.dispatchEvent(event);
    }
}
exports.DomElement = DomElement;
